var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { load, loadLast } from "framework/state/loader";
import { NoEntityError } from "framework/validation/validatableentity";
import { updateByCollectionResponse } from "framework/state/collection";
import { apiDeleteCompetitor, apiGetCompetitions, apiGetCompetitors } from "../../endpoint";
import { RegistrationState as RegistrationStateEnum } from "../../entity";
import { createSelector } from "react-sweet-state";
var CompetitionsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), openCompetitionIds: [] });
// Competitiors
export var getRegistrationSubStore = function (state, competitorId, competitionId) {
    return state.registration_states.find(function (s) { return s.competitorId == competitorId && s.competitionId == competitionId; });
};
var CompetitorsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), openCompetitorCompetitionIds: [] });
var RegistrationStateDefaults = __assign(__assign({}, LoadingStateDefaults), { competitorId: null, competitionId: null, registered: true, error: null, showDialog: false });
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { competitions: CompetitionsStateDefaults, competitors: CompetitorsStateDefaults, registration_states: [], not_logged: false });
// Actions
var loadCompetitions = function (eventId, eventCompetitionId, order) {
    if (order === void 0) { order = "type"; }
    return function (store) {
        store.setState(function (draft) {
            draft.competitions.collection = [];
            draft.competitions.openCompetitionIds = [];
        });
        var filter = "eventCompetitionId=".concat(eventCompetitionId);
        var loader = function () { return apiGetCompetitions(eventId, filter, order); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.competitions, response);
                // draft.competitions.openCompetitionIds = draft.competitions.collection.map(c => c.id);
                draft.competitions.openCompetitionIds = [];
            });
        };
        loadLast(store, loader, stateProducer, function (s) { return s.competitions; });
    };
};
var setCompetitionOpenOrClosed = function (competitionId) { return function (store) {
    store.setState(function (draft) {
        var index = draft.competitions.openCompetitionIds.indexOf(competitionId);
        if (index > -1) {
            draft.competitions.openCompetitionIds.splice(index, 1);
        }
        else {
            draft.competitions.openCompetitionIds.push(competitionId);
        }
    });
}; };
var setAllCompetitionsClosed = function () { return function (store) {
    store.setState(function (draft) {
        draft.competitions.openCompetitionIds = [];
    });
}; };
var setAllCompetitionsOpen = function () { return function (store) {
    store.setState(function (draft) {
        draft.competitions.openCompetitionIds = draft.competitions.collection.map(function (c) { return c.id; });
    });
}; };
var setCompetitorOpenOrClosed = function (competitorId, competitionId) { return function (store) {
    store.setState(function (draft) {
        var index = draft.competitors.openCompetitorCompetitionIds.indexOf("".concat(competitorId, "_").concat(competitionId));
        if (index > -1) {
            draft.competitors.openCompetitorCompetitionIds.splice(index, 1);
        }
        else {
            draft.competitors.openCompetitorCompetitionIds.push("".concat(competitorId, "_").concat(competitionId));
        }
    });
}; };
var loadCompetitors = function (eventId, eventCompetitionId) { return function (store) {
    store.setState(function (draft) {
        draft.competitors.collection = [];
    });
    var loader = function () { return apiGetCompetitors(eventId, eventCompetitionId); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.competitors, response);
            draft.registration_states = draft.competitors.collection.map(function (c) {
                return __assign(__assign({}, RegistrationStateDefaults), { competitorId: c.competitorId, competitionId: c.competitionId, registered: c.registrationState === RegistrationStateEnum.Registered });
            });
        });
    };
    loadLast(store, loader, stateProducer, function (s) { return s.competitors; });
}; };
var cancelRegistrationOfCompetitor = function (eventId, competitionId, competitorId) { return function (store) {
    store.setState(function (draft) {
        var s = getRegistrationSubStore(draft, competitorId, competitionId);
        s.showDialog = false;
    });
    var loader = function () { return apiDeleteCompetitor(eventId, competitionId, competitorId); };
    var getRegistrationState = function (s) {
        return s.registration_states.find(function (x) { return x.competitorId === competitorId && x.competitionId === competitionId; });
    };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            var rs = getRegistrationState(draft);
            if (response.succeeded) {
                rs.registered = false;
                rs.error = null;
            }
            else {
                rs.error = "Odhlášení ze soutěže se nezdařilo.";
                if (response.status.toString() === "401") {
                    draft.not_logged = true;
                }
            }
        });
    };
    load(store, loader, stateProducer, getRegistrationState);
}; };
var resetNotLoggedFlag = function () { return function (store) {
    store.setState(function (draft) {
        draft.not_logged = false;
    });
}; };
var closeConfirmDialog = function (competitorId, competitionId) { return function (store) {
    store.setState(function (draft) {
        var s = getRegistrationSubStore(draft, competitorId, competitionId);
        s.showDialog = false;
    });
}; };
var showConfirmDialog = function (competitorId, competitionId) { return function (store) {
    store.setState(function (draft) {
        var s = getRegistrationSubStore(draft, competitorId, competitionId);
        s.showDialog = true;
    });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadCompetitors: loadCompetitors,
        cancelRegistrationOfCompetitor: cancelRegistrationOfCompetitor,
        resetNotLoggedFlag: resetNotLoggedFlag,
        showConfirmDialog: showConfirmDialog,
        closeConfirmDialog: closeConfirmDialog,
        loadCompetitions: loadCompetitions,
        setCompetitionOpenOrClosed: setCompetitionOpenOrClosed,
        setCompetitorOpenOrClosed: setCompetitorOpenOrClosed,
        setAllCompetitionsClosed: setAllCompetitionsClosed,
        setAllCompetitionsOpen: setAllCompetitionsOpen,
    },
    name: "EventCalendarCompetitors"
});
var useState = createHook(store);
var getRegistrationSubState = createSelector(function (__) { return null; }, function (state, props) { return state.registration_states.find(function (s) { return s.competitorId === props.competitorId && s.competitionId === props.competitionId; }); }, function (__, comp_store) { return comp_store; });
var useRegistrationSubState = createHook(store, {
    selector: getRegistrationSubState,
});
export { StateDefaults as EventCalendarCompetitorsDefaults, useState as useEventCalendarCompetitors, useRegistrationSubState, };
